import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // bisa ganti ke "smooth" kalau mau animasi
    });
  }, [pathname]);

  return null; // tidak render apapun
};

export default ScrollToTop;
